import { FormikContextType, getIn } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IQuestion } from 'types/Question.types';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { isAnswerEmpty, validateColorInput } from 'utils/validation';
import { useAllowIncompleteAnswers } from 'utils/hooks/useTemplateConfigureParams';

export const useValidateColorInput = (
  question: IQuestion,
  context: FormikContextType<any>
) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const allowIncompleteAnswers = useAllowIncompleteAnswers();
  const { isFormValid } = useSelector(
    (state: IRootReducerState) => state.formInfo
  );

  useEffect(() => {
    const fieldValue = getIn(context.values, question.initialKey);
    const skipBecauseUnanswered =
      allowIncompleteAnswers && isAnswerEmpty(fieldValue);
    if (question.required && !skipBecauseUnanswered) {
      const fieldName = question.name;
      const error = validateColorInput(fieldValue, fieldName, t);

      if (error) {
        setErrorMessage(error);
        context.setFieldError(question.initialKey, error);
      } else {
        setErrorMessage('');
        context.setFieldError(question.initialKey, undefined);
      }
    } else {
      setErrorMessage('');
    }
  }, [
    getIn(context.values, question.initialKey),
    question.required,
    allowIncompleteAnswers,
  ]);

  useEffect(() => {
    if (errorMessage) {
      context.setFieldError(question.initialKey, errorMessage);
    } else {
      context.setFieldError(question.initialKey, undefined);
    }
  }, [errorMessage, isFormValid]);
  return errorMessage;
};
